import { IsoString } from '@tapestry/types';

/**
 * Get the the iteration number of the weekday within the month
 * i.e. if the weekday is the first monday of the month, the iteration will be `1`
 */
export const getWeekdayIterationWithinMonth = (isostring: IsoString) => {
  return Math.ceil(new Date(isostring).getDate() / 7);
};
